import {Id} from './id.type'

export class Possibility {
  id: Id
  question_id: Id
  label: string
  weight: number
  index: number

  constructor({question_id, label, weight}: any) {
    this.question_id = question_id
    this.label = label || ''
    this.weight = weight
  }
}
